import * as React from 'react';

import CHARILOTO3 from '@/assets/icons/logo_chariloto_3.svg';
import CHARILOTO5 from '@/assets/icons/logo_chariloto_5.svg';
import CHARILOTO_SELECT from '@/assets/icons/logo_chariloto_select.svg';
import CHARILOTO from '@/assets/icons/logo_chariloto-1.svg';
import DOKANTO4TWO from '@/assets/icons/logo_dokanto4two.svg';
import DOKANTO7 from '@/assets/icons/logo_dokanto7.svg';
import { MultiraceType } from '@/lib/apollo/types/gen/graphql';

interface MultiraceLogoProps {
  multiraceType: MultiraceType;
  width?: string;
  height?: string;
}

const MultiraceLogo: React.FC<MultiraceLogoProps> = ({
  multiraceType,
  width,
  height,
}) => {
  const styles = { width, height };

  switch (multiraceType) {
    case MultiraceType.Chariloto: {
      return <img src={CHARILOTO} style={{ ...styles }} alt="チャリロト" />;
    }
    case MultiraceType.CharilotoSelect: {
      return (
        <img
          src={CHARILOTO_SELECT}
          style={{ ...styles }}
          alt="チャリロト・セレクト"
        />
      );
    }
    case MultiraceType.Chariloto3: {
      return <img src={CHARILOTO3} style={{ ...styles }} alt="チャリロト3" />;
    }
    case MultiraceType.Chariloto5: {
      return <img src={CHARILOTO5} style={{ ...styles }} alt="チャリロト5" />;
    }
    case MultiraceType.Dokanto7: {
      return <img src={DOKANTO7} style={{ ...styles }} alt="Dokanto!7" />;
    }
    case MultiraceType.Dokanto4two: {
      return <img src={DOKANTO4TWO} style={{ ...styles }} alt="Dokanto!4two" />;
    }
    default: {
      return <></>;
    }
  }
};

export default MultiraceLogo;
